import type { FC, PropsWithChildren } from "react";

import type { TCalloutAssetProps } from "./Callout.config";

export const CalloutAssetWrapper: FC<
  PropsWithChildren<TCalloutAssetProps>
> = ({ children }) => (
  <>
    { children ? (
      <div className="col-start-1 row-start-1 row-span-2 self-stretch">
        { children }
      </div>
    ) : null }
  </>
);
